// User-facing copy: reading. Moved from the web app (components/ClubHome.tsx, components/DatesEditor.tsx, components/FinishCards.tsx, components/MineBlock.tsx, components/PacePicker.tsx, components/PlanSheet.tsx, components/ProgressEditor.tsx, components/StartBook.tsx, pages/club/NowTab.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/ClubHome.tsx */
export const clubHome = {
    justNow: "just now",
    h: (hrs) => `${hrs}h`,
    w: (round) => `${round}w`,
    sinceThisMonth: (when, x) => `since ${when} · ${x} this month`,
    oneYear: "one year",
    years: (years) => `${years} years`,
    since: (when) => `since ${when}`,
    yourClubSStory: "Your club's story starts with the first book.",
    member: "member",
    members: "members",
    bookRead: "book read",
    booksRead: "books read",
    pages: "pages",
    meeting: "meeting",
    meetings: "meetings",
    comment: "comment",
    comments: "comments",
    averageRating: "average rating",
    theClubInNumbers: "The club in numbers",
    bestLoved: "Best loved",
    read: (toLocaleDateString) => ` · read ${toLocaleDateString}`,
    you: "You",
    and: (join, others, x) => `${join} and ${others} ${x}`,
    other: "other",
    others: "others",
    someone: "Someone",
    and2: (join, x) => `${join} and ${x}`,
    newPostsOnThe: (count) => `${count} new posts on the noticeboard`,
    postedOnTheNoticeboard: (who) => `${who} posted on the noticeboard`,
    startedTheClub: (who) => `${who} started the club`,
    joined: (who) => `${who} joined`,
    madeTheClubOpen: "made the club open: anyone can join",
    listedTheClubPeople: "listed the club: people can ask to join",
    madeTheClubPrivate: "made the club private",
    started: (who) => `${who} started `,
    theClubVotedFor: "The club voted for it",
    sTurnToPick: (who) => `${who}'s turn to pick`,
    pickedBy: (x) => `Picked by ${x}`,
    you2: "you",
    ratedOnAverage: (toFixed) => `rated ${toFixed} on average`,
    suggested: (who) => `${who} suggested `,
    aVoteOpenedOn: "A vote opened on the next book",
    openedIt: (who, ago) => `${who} opened it · ${ago}`,
    wonTheVote: " won the vote",
    theVoteClosed: "The vote closed",
    meetingSetFor: "Meeting set for ",
    aNewDate: "a new date",
    finished: (who) => `${who} finished `,
    youAre: "You are",
    is: (name) => `${name} is`,
    someoneIs: "Someone is",
    nowAnAdmin: "now an admin",
    noLongerAnAdmin: "no longer an admin",
    recentActivity: "Recent activity",
    loading: "Loading…",
    seeMore: "See more",
    p: (round, percent) => `p. ${round} · ${percent}%`,
    you3: " (you)",
    joined2: (toLocaleDateString) => `Joined ${toLocaleDateString}`,
    manage: (name) => `Manage ${name}`,
    makeAdmin: "Make admin",
    removeAdmin: "Remove admin",
    removeFromClub: "Remove from club",
    removeAndBlock: "Remove and block",
    joined3: "Joined",
    booksWithTheClub: "Books with the club",
    finished2: (x) => `${x} finished`,
    notStarted: "not started",
    lastActive: "Last active",
    notYet: "not yet",
    yourLibraryCard: "Your library card",
    sLibraryCard: (name) => `${name}'s library card`,
    removeAndBlockThem: (name) => `Remove ${name} and block them? They won't be able to join again, ask to, or use an invite link.`,
    removeFromTheClub: (name, x) => `Remove ${name} from the club?${x}`,
    theClubIsOpen: " The club is open, so they could join again.",
    remove: "Remove",
    keep: "Keep",
    today: "today",
    yesterday: "yesterday",
    daysAgo: (days) => `${days} days ago`,
    weeksAgo: (round) => `${round} weeks ago`,
    genres: "Genres",
    moreGenres: "More genres",
    whatTheClubTends: "What the club tends to read",
    noGenresYet: "No genres yet",
    editGenres: "Edit genres",
    pickUpToThey: (MAX_CLUB_GENRES, x, x2) => `Pick up to ${MAX_CLUB_GENRES}${x}. They show on the Club tab and the invite page.${x2}`,
    chosen: (length) => ` (${length} chosen)`,
    theFirstFewMatch: " The first few match books your club has finished.",
    save: "Save",
    cancel: "Cancel",
    members2: "Members",
    owner: "Owner",
    ownerAdmins: "Owner & admins",
    newestMembers: "Newest members",
    seeAllMembers: (length) => `See all ${length} members`,
    m: (mins) => `${mins}m`,
    d: (days) => `${days}d`,
};
/** components/DatesEditor.tsx */
export const datesEditor = {
    started: "Started",
    finished: "Finished",
    marksItFinishedWith: "Marks it finished with these dates. Ratings open; nobody's progress changes.",
    addAsFinished: "Add as finished",
    saveDates: "Save dates",
    cancel: "Cancel",
};
/** components/FinishCards.tsx */
export const finishCards = {
    youFinished: "You finished",
    yourRating: "Your rating",
    firstReactionOneLine: "First reaction, one line. Only other finishers see it.",
    sayTheThingYou: "Say the thing you'd say closing the book",
    joinTheFinishers: "Join the finishers",
    bothOptionalYouCan: "Both optional. You can rate later on the Shelf.",
    theClubFinished: (title) => `The club finished ${title}`,
    youReAt: "You're at ",
    keepReading: "Keep reading",
    nothingChangesTheEnding: "nothing changes; the ending stays sealed until you get there",
    iMDoneWith: "I'm done with it",
    opensTheWholeDiscussion: "opens the whole discussion for you",
    the: "The ",
    isUpEitherWay: " is up either way.",
    ratingIfYouWant: "Rating, if you want",
    aLineOnWhy: "A line on why, optional",
    markAsDoneWith: "Mark as done with",
    back: "Back",
    doneWith: "Done with ",
    youLlBeMarked: "? You'll be marked \"didn't finish\", the whole discussion opens for you, and your rating stays out of the club average.",
    cancel: "Cancel",
};
/** components/MineBlock.tsx */
export const mineBlock = {
    pOf: (pageAt, pages) => `p. ${pageAt} of ${pages} · `,
    you: "You",
    didYouReadIt: "Did you read it?",
    iVeReadIt: "I've read it",
    readingItNow: "Reading it now",
    didnTReadIt: "Didn't read it",
    yourRatingClear: "your rating · clear",
    yourRating: "your rating",
};
/** components/PacePicker.tsx */
export const pacePicker = {
    usualPace: "Usual pace",
    pagesADay: "Pages a day",
};
/** components/PlanSheet.tsx */
export const planSheet = {
    planTheRead: "Plan the read",
    planThisStretchFrom: (from) => `Plan this stretch · from p. ${from}`,
    close: "Close",
    pages: (total) => ` · ${total} pages`,
    started: (dateShort) => `Started ${dateShort}`,
    fromP: (from) => `From p. ${from}`,
    meeting: (dateShort) => ` · meeting ${dateShort}`,
    noMeetingDateYet: " · no meeting date yet.",
    aboutPagesADay: (paceToday) => `about ${paceToday} pages a day`,
    yourUsualIs: (usualPace) => `. Your usual is ${usualPace}.`,
    landmarksGetDatesOnce: " Landmarks get dates once there is one.",
    howManyPagesIs: "How many pages is your copy?",
    part: (x) => `Part ${x}`,
    landmarkName: "Landmark name",
    toP: "to p. ",
    page: "Page",
    nextStretch: "next stretch",
    date: "Date",
    setByHand: "set by hand",
    fromYourPace: "from your pace",
    noDateYet: "no date yet",
    reset: "reset",
    edit: "edit",
    usePace: "use pace",
    removeLandmark: "Remove landmark",
    halfwayBetweenAndIs: (x, x2) => `Halfway between ${x} and ${x2} is `,
    theStart: "the start",
    p: (lo) => `p. ${lo}`,
    theEnd: "the end",
    p2: (hi) => `p. ${hi}`,
    p3: (page) => `p. ${page}`,
    addALandmark: "Add a landmark",
    meetingCovers: "Meeting covers",
    theWholeBook: "the whole book",
    through: (x) => `through ${x}  `,
    p4: (page, x) => `· p. ${page}${x}`,
    closestToYourUsual: (usualPace) => ` · closest to your usual ${usualPace} a day`,
    anotherPage: "another page",
    pageTheMeetingCovers: "Page the meeting covers up to",
    atYourUsual: "At your usual ",
    aDayYouD: (reachAtUsual) => ` a day you'd reach about p. ${reachAtUsual} by the meeting.`,
    thatSAboutPages: (pace) => `That's about ${pace} pages a day for this stretch.`,
    cancel: "Cancel",
    saving: "Saving…",
    savePlan: "Save plan",
};
/** components/ProgressEditor.tsx */
export const progressEditor = {
    howYouCountThis: "How you count this book",
    pages: "Pages",
    percent: "Percent",
    audio: "Audio",
    closeWithoutSaving: "Close without saving",
    howLongIsThe: "How long is the audiobook?",
    hoursLong: "Hours long",
    h: "h",
    minutesLong: "Minutes long",
    page: "Page",
    of: (pages) => `of ${pages}`,
    hours: "Hours",
    minutes: "Minutes",
    of2: (duration) => `of ${duration}`,
    saving: "Saving…",
    markFinished: "Mark finished",
    save: "Save",
    syncedFromHardcover: " synced from Hardcover",
    doneWithIt: "Done with it",
    readItBeforeSitting: "Read it before · sitting out",
    p: (pageAt) => `p. ${pageAt}`,
};
/** components/StartBook.tsx */
export const startBook = {
    youPickNextOnce: "You pick next, once the club finishes ",
    finish: "Finish ",
    itGoesOnThe: "It goes on the finished shelf dated today, and ",
    startsRatingsAndThe: " starts. Ratings and the discussion stay open.",
    start: "Start ",
    forTheClub: " for the club?",
    itBecomesTheBook: "It becomes the book on Reading for everyone.",
    working: "Working…",
    finishAndStart: "Finish and start",
    startIt: "Start it",
    cancel: "Cancel",
    startReading: "Start reading",
};
/** pages/club/NowTab.tsx */
export const tab = {
    daysAgo: (x) => `${x} days ago`,
    yesterday: "yesterday",
    today: "today",
    tomorrow: "tomorrow",
    inDays: (days) => `in ${days} days`,
    meetingPage: "Meeting page",
    hosting: (name) => ` · ${name} hosting`,
    youRe: (x) => ` · you're ${x}`,
    going: "going",
    notGoing: "not going",
    aMaybe: "a maybe",
    dateMovedStillGoing: " · date moved, still going?",
    noDateSetThe: "No date set · the agenda is here anyway",
    pinned: (firstLine) => `Pinned: ${firstLine}`,
    noticeboard: (name, x) => `${name} · Noticeboard${x}`,
    until: (toLocaleDateString) => ` · until ${toLocaleDateString}`,
    newOnTheNoticeboard: (newPosts) => `${newPosts} new on the noticeboard`,
    stillReading: "Still reading",
    onYourOwnTime: "on your own time",
    books: (length) => `${length} books`,
    pOf: (pageAt, pages) => `p. ${pageAt} of ${pages} · `,
    theClubFinishedIt: (dateShort) => ` · the club finished it ${dateShort}`,
    voteOnTheNext: "Vote on the next book",
    theVoteIsIn: "The vote is in",
    theVoteTied: "The vote tied",
    of: (x, x2, x3, voted, members) => `${x}${x2} · ${x3} · ${voted} of ${members}`,
    leads: (title) => `${title} leads · `,
    closes: (toLocaleDateString) => `closes ${toLocaleDateString}`,
    open: "open",
    youVeVoted: "you've voted",
    youHavenTVoted: "you haven't voted",
    startItFromThe: "start it from the shelf when the club is ready",
    anAdminStartsIt: "an admin starts it from the shelf",
    breakTheTieOn: "Break the tie on the shelf",
    anAdminBreaksThe: "An admin breaks the tie",
    openAVoteOn: "Open a vote on the next book",
    adminsTheOnDeck: "Admins · the on-deck list becomes the ballot",
    itSYourTurn: "It's your turn to pick",
    itSSTurn: (name) => `It's ${name}'s turn to pick`,
    fromTheOnDeck: "From the on-deck list, on the shelf",
    itSJustYou: "It's just you so far",
    inviteSomeone: "Invite someone",
    planYourFirstMeeting: "Plan your first meeting",
    aTimeAndA: "A time and a place; the agenda fills in later",
    sayHowTheClub: "Say how the club works",
    howOftenYouMeet: "How often you meet, whether unfinished readers come",
    aroundTheClub: "Around the club",
    pages: (pages) => ` · ${pages} pages`,
    started: (dateShort) => `Started ${dateShort}`,
    day: " · day ",
    whereEveryoneElseIs: "Where everyone else is",
    justYouSoFar: "just you so far",
    reader: "reader",
    readers: "readers",
    setTheNextMeeting: "Set the next meeting",
    thePlanPicksUp: "The plan picks up from p. ",
    onceThereSA: " once there's a date.",
    coversTheWholeBook: " · covers the whole book",
    through: (x) => ` · through ${x}`,
    p: (to) => `p. ${to}`,
    stretchEndedAtP: "Stretch ended at p. ",
    met: (dateShort) => ` · met ${dateShort}`,
    throughP: (to) => `Through p. ${to}`,
    finish: "Finish",
    youReThere: "you're there",
    toGo: " to go",
    p2: (pageAt) => `p. ${pageAt}`,
    of2: (pages, percent) => `of ${pages} · ${percent}%`,
    of3: (duration, percent) => `of ${duration} · ${percent}%`,
    pOf2: (pageAt, pages) => `p. ${pageAt} of ${pages}`,
    mAgo: (max) => `${max}m ago`,
    hAgo: (hrs) => `${hrs}h ago`,
    dAgo: (round) => `${round}d ago`,
    aheadOfPlan: "ahead of plan",
    toStayOnPlan: (paceLabel) => `${paceLabel} to stay on plan`,
    finished: " Finished",
    stoppedAt: (percent) => `Stopped at ${percent}%`,
    doneWithItEverything: "done with it · everything's open now",
    readItBefore: "Read it before",
    sittingItOutNothing: "sitting it out · nothing is sealed for you",
    syncedFromHardcover: (x) => ` synced from Hardcover${x}`,
    readingItAfterAll: "Reading it after all",
    close: "Close",
    update: "Update",
    saved: "Saved.",
    noteToSelf: "Note to self…",
    noteToSelf2: "Note to self",
    save: "Save",
    leaveANoteForward: "Leave a note forward",
    note: "note",
    notes: "notes",
    notebook: "notebook",
    stoppedAt2: (percent) => `stopped at ${percent}%`,
    readItBefore2: "read it before",
    viaHardcover: (ago) => `via Hardcover · ${ago}`,
    notStarted: "not started",
    whereThePlanIs: "Where the plan is today",
    pToday: (pageAt) => `p. ${pageAt} today`,
    hereToday: "here today",
    toFinishBy: (dateShort) => ` to finish by ${dateShort}`,
    you: "You",
    of4: (pg, pages) => `${pg} of ${pages}`,
    readersAroundPTo: (length, pageAt, pageAt2) => `${length} readers around p. ${pageAt} to p. ${pageAt2}`,
    readersAroundTo: (length, lo, hi) => `${length} readers around ${lo}% to ${hi}%`,
    past: (lm) => `past ${lm}`,
    more: (x) => `${x} more ›`,
    bookActions: "Book actions",
    finishThisBook: "Finish this book",
    putBackOnDeck: "Put back on deck",
    editStartDate: "Edit start date",
    planThisStretchFrom: (to) => `Plan this stretch · from p. ${to}`,
    editThePlan: "Edit the plan",
    planTheRead: "Plan the read",
    moveToFinishedEveryone: (title) => `Move ${title} to Finished? Everyone can still update progress and read the discussion, and ratings open.`,
    shelveItForNow: "Shelve it for now? Progress is kept and it can be started again later.",
    yes: "Yes",
    cancel: "Cancel",
    stillTalkingAbout: (title) => `Still talking about ${title}`,
    last: (x, ago) => `${x}last ${ago}`,
    new: (unread) => `${unread} new · `,
    noMessagesYet: "No messages yet",
    message: "message",
    messages: "messages",
    startTheConversation: "Start the conversation",
    sealedAheadOfYou: (lockedCount) => `${lockedCount} sealed ahead of you`,
    nothingSealedForYou: "nothing sealed for you",
    last2: (ago) => ` · last ${ago}`,
    orChooseFromThe: (deck) => `Or choose from the ${deck} on deck`,
    nothingOnTheNightstand: "Nothing on the nightstand yet",
    pickTheFirstBook: "Pick the first book",
    pickTheNextBook: "Pick the next book",
    pickTheClubS: "Pick the club's first book and everyone's progress shows up here.",
    pickTheClubS2: "Pick the club's next book and everyone's progress shows up here.",
    waitingForTheFirst: "Waiting for the first book",
    waitingForTheNext: "Waiting for the next book",
    suggestABook: "Suggest a book",
    whenAnAdminPicks: "When an admin picks it, everyone's progress shows up here.",
    anAdminWillPick: "An admin will pick the first book.",
    finished2: (finished) => `${finished} finished`,
    pages2: (max) => `${max} pages`,
    by: (dateShort) => ` by ${dateShort}`,
    finished3: (x) => `finished${x}`,
    readers2: (length) => `${length} readers`,
    finished4: (length) => `${length} finished`,
};
//# sourceMappingURL=reading.js.map